/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { HealthService } from './health.service';
import { HttpClient } from '@angular/common/http';
import { ServiceConfiguration, ServiceName } from '../../../assets/config/environment';

export class KeycloakHealthService extends HealthService {
    private preferredKeycloakHost: string;
    constructor(http: HttpClient, serviceUrls: ServiceConfiguration[], healthEndpoint: string) {
        super(http, ServiceName.IDM, serviceUrls, healthEndpoint, true, false);
    }

    // override keycloak health check initialization such that we prefer the keycloak host provided by the login cookie.
    protected override initializeHealthChecks() {
        this.setPreferredKeycloakHost();
        this.urls.sort((a, b) => this.keycloakServiceUrlPrioritySort(a, b, this.preferredKeycloakHost));
        console.debug(`Keycloak url sorted: ${this.urls.map((url) => url.url).join(', ')}`);
        this.runSequentialHealthCheckInitialization();
        this.scheduleHealthChecks();
    }

    private setPreferredKeycloakHost() {
        const regExpMatchArray = document?.cookie?.match(new RegExp('(^| )CURRENT_KEYCLOAK_HOST=([^;]+)'));
        this.preferredKeycloakHost = regExpMatchArray ? decodeURIComponent(regExpMatchArray[2]) : undefined;
        console.debug(`Keycloak cookie preferred keycloak host url: ${this.preferredKeycloakHost}`);
    }

    // sorts the preferred keycloak host to the beginning of the urls list
    public keycloakServiceUrlPrioritySort(a: ServiceConfiguration, b: ServiceConfiguration, preferredKeycloakHost: string) {
        return Number(b.url === preferredKeycloakHost) - Number(a.url === preferredKeycloakHost);
    }

}
